// extracted by mini-css-extract-plugin
export default {"SixthPage":"SixthPage_SixthPage__N0o-o","pcLogo":"SixthPage_pcLogo__FE-QJ"};